<div class="forbidden-container">
    <nz-result nzStatus="403" nzTitle="403 Forbidden">
      <p nz-result-extra>Sorry, you don't have permission to access this page.</p>
      <button nz-button nzType="primary" routerLink="/">Go Back Home</button>
    </nz-result>
  </div>